// frontend/src/utils/permissions.js
// Client-side permission checking — mirrors backend/config/permissions.js

export const PERMISSIONS = {
  BLOG_CREATE: 'blog.create',
  BLOG_EDIT: 'blog.edit',
  BLOG_DELETE: 'blog.delete',
  BLOG_PUBLISH: 'blog.publish',
  BLOG_SUBMIT: 'blog.submit',
  EVENT_CREATE: 'event.create',
  EVENT_EDIT: 'event.edit',
  EVENT_DELETE: 'event.delete',
  USER_VIEW: 'user.view',
  USER_MANAGE: 'user.manage',
  USER_DELETE: 'user.delete',
  CHILD_MANAGE: 'child.manage',
  PERMISSIONS_MANAGE: 'permissions.manage',
  ADMIN_DASHBOARD: 'admin.dashboard',
};

export const ROLE_PRESETS = {
  admin: ['*'],
  gruppenleiter: [
    'blog.create',
    'blog.edit',
    'blog.publish',
    'event.create',
    'event.edit',
    'user.view',
  ],
  eltern: [
    'child.manage',
  ],
  kind: [
    'blog.submit',
  ],
};

export const hasPermission = (user, permission) => {
  if (!user) return false;
  const userRole = user.role || 'kind';
  const rolePermissions = ROLE_PRESETS[userRole] || [];
  const customPermissions = user.customPermissions || [];

  if (rolePermissions.includes('*') || customPermissions.includes('*'))
    return true;

  return (
    rolePermissions.includes(permission) ||
    customPermissions.includes(permission)
  );
};

export const canEditContent = (user, contentType) => {
  if (!user) return false;
  switch (contentType) {
    case 'event':
      return hasPermission(user, PERMISSIONS.EVENT_EDIT);
    case 'blog':
      return hasPermission(user, PERMISSIONS.BLOG_EDIT);
    case 'team':
      return user.role === 'admin' || user.role === 'gruppenleiter';
    default:
      return false;
  }
};

